import { DEMO_EMAIL, DEMO_PASSWORD, demoUser } from '../config';
import { error, route, type DemoRoute } from '../router';

export const authHandlers: DemoRoute[] = [
  route('POST', '/auth/login', ({ body }) => {
    const { email, password } = (body ?? {}) as { email?: string; password?: string };
    if (email?.trim().toLowerCase() !== DEMO_EMAIL || password !== DEMO_PASSWORD) {
      return error(401, 'Incorrect email or password');
    }
    return {
      access_token: 'demo-access-token',
      refresh_token: 'demo-refresh-token',
      token_type: 'bearer',
      expires_in: 3600,
      refresh_expires_in: 86400, // 24h — the session checker derives session_expiry from this
      user: demoUser,
    };
  }),
  route('POST', '/auth/refresh', () => ({
    access_token: 'demo-access-token',
    token_type: 'bearer',
    expires_in: 3600,
    refresh_expires_in: 86400,
  })),
  route('GET', '/auth/me', () => demoUser),
  route('POST', '/auth/logout', () => ({ message: 'ok' })),
];
